<template>	
	<el-select v-model="nicheng" :placeholder="(value)?value:'请输入昵称/手机'" filterable remote clearable :remote-method="Fujilie" :loading="loading" value-key="id" @change="Xuanzeshangji" style="width: 100%;">
		<el-option v-for="l in lie" :label="l.nicheng" :value="l" />
	</el-select>
</template>

<script>
	var that;
	export default {
		data() {
			return {
				nicheng: '',
				lie: [],
				loading:false
			};
		},
		props: {
			value: {
				type: [String],
			},
			hyid: {
				type: String,
			},
			touxiang: {
				type: [String],
			}
		},
		created() {
			that = this;	
			// that.nicheng=that.value;
		},
		methods: {
			Fujilie(guanjianci) {	
				that.loading=true;
				this.$post('k=huiyuan', {ye: 1,jitiao: 10,guanjianci: guanjianci}, function(s) {
					if (s.shi == 1) {						
						setTimeout(function(){
							that.loading=false;
							that.lie = s.shu.lie;	
						},500)					
					}else{
						that.lie=[];
					}
				});
			},
			Xuanzeshangji(e) {	
				this.$emit('input', e.value || '');
				this.$emit('update:hyid', e.id || '');
				this.$emit('update:touxiang', e.touxiang || '');
			}		
		}
	}
</script>

<style>


</style>
